import { PermissionType } from '@/types/permission';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PermissionState = {
  dataPermission: PermissionType[];
};

export const permissionInitialState: PermissionState = {
  dataPermission: [],
};

const slice = createSlice({
  name: 'permission',
  initialState: permissionInitialState,
  reducers: {
    setPermissionAction(state, { payload }: PayloadAction<{ dataPermission: PermissionType[] }>) {
      state.dataPermission = payload.dataPermission;
    },
  },
});

export const { setPermissionAction } = slice.actions;
export default slice.reducer;
